<script lang="ts">
  import { Card, CardHeader, Col, Image, Row } from "sveltestrap";
  import {tempId} from "../../../store"
  import data from "../../../Data/Users/Users.json";
  import SocialFriendsFooter from "./SocialFriendsFooter.svelte";
  let imgPath: string = "/assets/images";
  let setTempid:string
  tempId.subscribe((value)=>{
      setTempid = value
  })
</script>
<div class="tab-pane fade {setTempid === "top-friends" ? "active show" : ""}" id="timeline2" role="tabpanel" aria-labelledby="friends">
  <Row>
    {#each data.usercarddata as userData}
      <Col md="6" lg="6" xl="4" class="box-col-6">
        <Card class="custom-card">
          <CardHeader>
            <Image fluid src="{imgPath}/user-card/1.jpg" alt="" />
          </CardHeader>
          <div class="card-profile">
            <Image
              class="rounded-circle"
              src="{imgPath}/avtar/{userData.img}"
              alt=""
            />
          </div>
          <SocialFriendsFooter userData={userData}/>
        </Card>
      </Col>
    {/each}
  </Row>
</div>